import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import request from '@/utils/request';
/**
 * 配置区 - 获取系统菜单列表
 * @param {*} params
 * @returns
 */
export function getSystemMenus(params, module) {
  var url = '/decoration/decoration/get-system-menus';
  if (module === 'plat_custom') {
    url = '/plat/decoration/get-system-menus';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 金刚区 获取SASS板块列表
 * @param {*} params
 * @returns
 */
export function getUnionModule(params, module) {
  var url = '/decoration/decoration/get-union-module-plate';
  if (module === 'plat_custom') {
    url = '/plat/decoration/get-union-module-plate';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取图书分类列表
 * @param {*} params
 */
export function getBookCategoryList(params) {
  return request({
    url: '/decoration/decoration/get-union-book-cate',
    method: 'get',
    params: params
  });
}
/**
 * 客户级 获取礼包方案列表
 * @param {*} params
 * @returns
 */
export function getCustomerPackage(params) {
  return request({
    url: '/decoration/decoration/get-customer-package',
    method: 'get',
    params: params
  });
}
/**
 * 根据saas板块获取saas活动
 * @param {*} params
 * @returns
 */
export function getUnionActivity(params, module) {
  var url = '/decoration/decoration/get-union-activity-list';
  if (module === 'plat_custom') {
    url = '/plat/decoration/get-union-activity-list';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取组件对应图片库信息
 * @param {*} params
 * @returns
 */
export function getPictureByKey(params, module) {
  var url = '/decoration/decoration/get-picture-by-key';
  if (module === 'plat_custom') {
    url = '/plat/decoration/get-picture-by-key';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取组件列表
 * @param {*} params
 * @returns
 */
export function getComponents(params, module) {
  var url = "/decoration/decoration/widget";
  if (module === 'plat_custom') {
    url = "/plat/decoration/widget";
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取装修首页
 * @param {*} params
 * @returns
 */
export function getHome(module, params) {
  var url = {
    admin: '/decoration/decoration/home',
    channel: '/decoration/decoration/current-home',
    custom: '/decoration/decoration/home-by-customer',
    plat_custom: '/plat/decoration/home-by-customer',
    service_custom: '/kefu/decoration/home-by-customer',
    plat_service_custom: '/plat-service/decoration/home-by-customer'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取功能菜单列表
 * @param {*} params
 * @returns
 */
export function getCategory(params, module) {
  var url = {
    plat_custom: '/plat/decoration/category',
    service_custom: '/kefu/decoration/category',
    plat_service_custom: '/plat-service/decoration/category'
  }[module] || '/decoration/decoration/category';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取当日达菜单列表
 * @param {*} params
 * @returns
 */
export function getCategoryToday(params, module) {
  var url = {
    plat_custom: '/plat/decoration/category-today',
    service_custom: '/kefu/decoration/category-today',
    plat_service_custom: '/plat-service/decoration/category-today'
  }[module] || '/decoration/decoration/category-today';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 模板库 - 获取当日达菜单列表
 * @param {*} params
 * @returns
 */
export function getCategoryTodayTemplate(params, _, page_source) {
  var url = {
    platform: '/decoration/template/get-category-today',
    mall: '/decoration/template/get-mall-category-today',
    channel: '/decoration/template/get-channel-category-today'
  }[page_source];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 *  获取(get)/设置(set)风格设置
 * @param {*} params
 * @returns
 */
export function shopConfig(module, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
  var url = {
    admin: '/decoration/decoration/shop-config',
    custom: '/decoration/decoration/shop-config-by-customer',
    plat_custom: '/plat/decoration/shop-config-by-customer',
    service_custom: '/kefu/decoration/shop-config-by-customer',
    plat_service_custom: '/plat-service/decoration/shop-config-by-customer',
    channel: '/decoration/decoration/current-shop-config'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}
export function shopConfigSale(module, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
  var url = {
    admin: '/decoration/decoration/shop-config',
    custom: '/decoration/decoration/shop-config-by-customer-sales',
    plat_custom: '/plat/decoration/shop-config-by-customer',
    service_custom: '/kefu/decoration/shop-config-by-customer',
    plat_service_custom: '/plat-service/decoration/shop-config-by-customer',
    channel: '/decoration/decoration/current-shop-config'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}

/**
 * 获取装修日志列表
 * @param {*} params
 * @returns
 */
export function getLog(params, module) {
  var url = {
    admin: '/decoration/decoration/get-decoration-log',
    custom: '/decoration/decoration/get-customer-decoration-log',
    plat_custom: '/plat/decoration/get-customer-decoration-log',
    channel: '/decoration/decoration/get-shop-decoration-log'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取子页面装修日志列表
 * @param {*} params
 * @returns
 */
export function getChildLog(params, module) {
  var url = {
    admin: '/decoration/decoration/get-child-page-log',
    custom: '/decoration/decoration/get-child-page-log-customer',
    channel: '/decoration/decoration/get-child-page-log-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面列表 - 查看客户名称
 * @param {*} params
 * @returns
 */
export function showChildCustomName(params) {
  return request({
    url: '/decoration/decoration/show-child-customer-name',
    method: 'get',
    params: params
  });
}

/**
 *  获取(get)/设置(set)背景图原配置
 * @param {*} params 传递参数
 * @param {*} method 请求方式 get | post
 * @returns
 */
export function backgroundConfig(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  var module = arguments.length > 2 ? arguments[2] : undefined;
  var url = {
    admin: '/decoration/decoration/background-config',
    custom: '/decoration/decoration/background-config-by-customer',
    plat_custom: '/plat/decoration/background-config-by-customer',
    channel: '/decoration/decoration/current-background-config'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}

/**
 * 二级菜单 - 获取(get)/设置(set)背景图原配置
 * @param {*} params 传递参数
 * @param {*} method 请求方式 get | post
 * @returns
 */
export function backgroundConfigByCategory(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  var module = arguments.length > 2 ? arguments[2] : undefined;
  var url = {
    admin: '/decoration/decoration/background-config-by-category',
    custom: '/decoration/decoration/background-config-by-category-customer',
    plat_custom: '/plat/decoration/background-config-by-category-customer',
    channel: '/decoration/decoration/current-background-config-by-category'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}

/**
 * 单组件保存
 * @param {*} data
 * @returns
 */
export function update(data, module) {
  var url = "/decoration/decoration/update";
  if (module === 'plat_custom') {
    url = "/plat/decoration/update";
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 保存装修并发布
 * @param {*} data
 * @returns
 */
export function save(data, module) {
  var url = {
    admin: '/decoration/decoration/save',
    custom: '/decoration/decoration/save-by-customer',
    plat_custom: '/plat/decoration/save-by-customer',
    channel: '/decoration/decoration/current-save'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 保存装修并发布 - 二级菜单
 * @param {*} data
 * @returns
 */
export function saveCategory(data, module) {
  var url = {
    admin: '/decoration/decoration/save-by-category',
    custom: '/decoration/decoration/save-by-customer-category',
    plat_custom: '/plat/decoration/save-by-customer-category',
    channel: '/decoration/decoration/current-save-by-category'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 获取蛋糕品牌列表
 * @param {*} params
 * @returns
 */
export function getCakeBrands(params, module) {
  var url = '/decoration/decoration/cake-brands';
  if (module === 'plat_custom') {
    url = '/plat/decoration/cake-brands';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取点餐品牌图片
 * @param {*} params
 * @returns
 */
export function getFoodsBrandsImage(params, module) {
  var url = '/decoration/decoration/foods-brands-default-image';
  if (module === 'plat_custom') {
    url = '/plat/decoration/foods-brands-default-image';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取实体品牌列表
 * @param {*} params
 * @returns
 */
export function getShopBrands(params, module) {
  var url = '/decoration/decoration/shop-brands';
  if (module === 'plat_custom') {
    url = '/plat/decoration/shop-brands';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取当前账户所属渠道ID
 * @param {*} params
 * @returns
 */
export function getChannel(params) {
  return request({
    url: '/decoration/decoration/get-channelid',
    method: 'get',
    params: params
  });
}

/**
 * 获取二级页面装修类型菜单
 * @param {*} params
 * @returns
 */
export function getDecorationCategory(module, params) {
  var url = {
    admin: '/decoration/decoration/decoration-category',
    custom: '/decoration/decoration/decoration-category',
    plat_custom: '/plat/decoration/decoration-category',
    channel: '/decoration/decoration/current-decoration-category'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 二级页面装修首页
 * @param {*} params
 * @returns
 */
export function getHomeByCategory(module, params) {
  var url = {
    admin: '/decoration/decoration/home-by-category',
    custom: '/decoration/decoration/home-by-category-customer',
    plat_custom: '/plat/decoration/home-by-category-customer',
    channel: '/decoration/decoration/current-home-by-category'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取模板列表
 * @param {*} params
 * @returns
 */
export function getTemplateList(params, module) {
  var url = "/decoration/template/get-template";
  if (module === 'plat_custom') {
    url = "/plat/template/get-template";
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取渠道列表
 * @param {*} params
 * @returns
 */
export function getChannelList(params) {
  return request({
    url: '/decoration/template/channel-list',
    method: 'get',
    params: params
  });
}

/**
 * 确认生成模板
 * @param {*} data
 * @returns
 */
export function generateTemplate(data, module) {
  var url = {
    admin: '/decoration/template/generate-template',
    custom: '/decoration/template/generate-template-customer',
    plat_custom: '/plat/template/generate-template-customer',
    channel: '/decoration/template/generate-template-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

// 电影二级首页装修 banner图
export function movieBanner(data) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  var module = arguments.length > 2 ? arguments[2] : undefined;
  var url = "/decoration/banner/customer-config";
  if (module === 'plat_custom') {
    url = "/plat/banner/customer-config";
  }
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: data
  } : {
    data: data
  }));
}

/**
 * 获取城市列表
 * @param {*} params
 * @returns
 */
export function getCityList(params) {
  return request({
    url: '/products/movie/citys',
    method: 'get',
    params: params
  });
}

/**
 * 获取影院列表数据
 * @param {*} params
 * @returns
 */
export function getCinemaList(params, module) {
  var url = '/decoration/decoration/ciname-list';
  if (module === 'plat_custom') {
    url = '/plat/decoration/ciname-list';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取影片列表数据
 * @param {*} params
 * @returns
 */
export function getMovieList(params, module) {
  var url = '/decoration/decoration/movie-list';
  if (module === 'plat_custom') {
    url = '/plat/decoration/movie-list';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 获取电影产品分类数据
 * @param {*} params
 * @returns
 */
export function getDecorationList(params, module) {
  var url = "/decoration/decoration/widget-default-value";
  if (module === 'plat_custom') {
    url = "/plat/decoration/widget-default-value";
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 二级菜单弹窗 切换风格
 * @param {*} params
 * @returns
 */
export function switchStyle(params, url) {
  // const url = {
  // 	admin: '/decoration/decoration/category-switch-style',
  // 	custom: '/decoration/decoration/category-switch-style-by-customer',
  // 	plat_custom: '/plat/decoration/category-switch-style-by-customer',
  // 	channel: '/decoration/decoration/current-category-switch-style'
  // }[module]
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 子页面相关 - start
 */

/**
 * 子页面 - 获取子页面列表
 * @param {*} params
 * @returns
 */
export function getChildPageList(params, module) {
  var url = {
    admin: '/decoration/decoration/child-page-list',
    custom: '/decoration/decoration/child-page-list-customer',
    plat_custom: '/plat/decoration/child-page-list-customer',
    service_custom: '/kefu/decoration/child-page-list-customer',
    plat_service_custom: '/plat-service/decoration/child-page-list-customer',
    channel: '/decoration/decoration/child-page-list-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 子页面 - 获取装修首页 - 管理员纬度
 * @param {*} params
 * @returns
 */
export function getChildHomeAdmin(params, module) {
  var url = {
    admin: '/decoration/decoration/child-home',
    custom: '/decoration/decoration/child-home-customer',
    plat_custom: '/plat/decoration/child-home-customer',
    channel: '/decoration/decoration/child-home-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面 - 获取组件列表 - 管理员纬度
 * @param {*} params
 * @returns
 */
export function getChildWidgetAdmin(params, module) {
  var url = {
    admin: '/decoration/decoration/child-widget',
    custom: '/decoration/decoration/child-widget-customer',
    plat_custom: '/plat/decoration/child-widget-customer',
    channel: '/decoration/decoration/child-widget-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面 -  获取(get)/设置(set)背景图原配置 - 管理员纬度
 * @param {*} params 传递参数
 * @param {*} method 请求方式 get | post
 * @returns
 */
export function childBackgroundAdmin(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  var module = arguments.length > 2 ? arguments[2] : undefined;
  var url = {
    admin: '/decoration/decoration/child-background-config',
    custom: '/decoration/decoration/child-background-config-customer',
    plat_custom: '/plat/decoration/child-background-config-customer',
    channel: '/decoration/decoration/child-background-config-shop'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}

/**
 * 装修首页 - 获取头部配置
 * @param {*} params
 * @param {*} module
 * @returns
 */
export function getHeaderConfig(params, module) {
  var url = '/decoration/decoration-config/get-header-by-channel';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-config/get-header-by-customer';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 装修首页 - 保存头部配置
 * @param {*} data
 * @param {*} module
 * @returns
 */
export function setHeaderConfig(data, module) {
  var url = '/decoration/decoration-config/save-header-by-channel';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-config/save-header-by-customer';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 装修首页 - 获取边框圆角设置
 * @param {*} params
 * @param {*} module
 * @returns
 */
export function getBorderConfig(params, module) {
  var url = '/decoration/decoration-border/get-border-by-channel';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-border/get-border-by-customer';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 装修首页 - 保存边框圆角设置
 * @param {*} data
 * @param {*} module
 * @returns
 */
export function setBorderConfig(data, module) {
  var url = '/decoration/decoration-border/save-border-by-channel';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-border/save-border-by-customer';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 功能菜单 - 获取边框圆角设置
 * @param {*} params
 * @param {*} module
 * @returns
 */
export function getBorderConfigCategory(params, module) {
  var url = '/decoration/decoration-border/get-border-by-channel-category';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-border/get-border-by-customer-category';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 功能菜单 - 保存边框圆角设置
 * @param {*} data
 * @param {*} module
 * @returns
 */
export function setBorderConfigCategory(data, module) {
  var url = '/decoration/decoration-border/save-border-by-channel-category';
  if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
    url = '/decoration/decoration-border/save-border-by-customer-category';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 基础设置页 顶部导航获取跳转自定义装修风格菜单
 * @param {*} params
 * @returns
 */
export function getMenuList(params) {
  return request({
    url: '/decoration/decoration/category-header',
    method: 'get',
    params: params
  });
}
/**
 * 子页面 - 单组件保存 - 管理员纬度
 * @param {*} data
 * @returns
 */
export function childUpdateAdmin(data, module) {
  var url = "/decoration/decoration/child-update";
  if (module === 'plat_custom') {
    url = "/plat/decoration/child-update";
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 保存装修 - 管理员纬度
 * @param {*} data
 * @returns
 */
export function saveChildAdmin(data, module) {
  var url = {
    admin: '/decoration/decoration/save-child-page',
    custom: '/decoration/decoration/save-child-page-customer',
    plat_custom: '/plat/decoration/save-child-page-customer',
    channel: '/decoration/decoration/save-child-page-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 获取功能菜单 - 管理员纬度
 * @param {*} params
 * @returns
 */
export function getChildCategory(params, module) {
  var url = {
    admin: '/decoration/decoration/child-category',
    custom: '/decoration/decoration/child-category-customer',
    plat_custom: '/plat/decoration/child-category-customer',
    channel: '/decoration/decoration/child-category-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面 - 复制子页面链接 - 管理员纬度
 * @param {*} params
 * @returns
 */
export function copyChildLink(params, module) {
  var url = {
    admin: '/decoration/decoration/copy-child-link',
    custom: '/decoration/decoration/copy-child-link-customer',
    plat_custom: '/plat/decoration/copy-child-link-customer',
    channel: '/decoration/decoration/copy-child-link-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面 - 禁用/启用 - 管理员纬度
 * @param {*} data
 * @returns
 */
export function changeChildStatus(data, module) {
  var url = {
    admin: '/decoration/decoration/change-child-status',
    custom: '/decoration/decoration/change-child-status-customer',
    plat_custom: '/plat/decoration/change-child-status-customer',
    channel: '/decoration/decoration/change-child-status-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 删除子页面 - 管理员纬度
 * @param {*} data
 * @returns
 */
export function delChildPage(data, module) {
  var url = {
    admin: '/decoration/decoration/del-child-page',
    custom: '/decoration/decoration/del-child-page-customer',
    plat_custom: '/plat/decoration/del-child-page-customer',
    channel: '/decoration/decoration/del-child-page-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 修改名称
 * @param {*} data
 * @returns
 */
export function renameChildPage(data, url) {
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 客户复制渠道子页面
 * @param {*} data
 * @returns
 */
export function copyChildToCustom(data, module) {
  var url = "/decoration/decoration/copy-child-page-customer";
  if (module === 'plat_custom') {
    url = "/plat/decoration/copy-child-page-customer";
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 渠道级 复制客户子页面到渠道
 * @param {*} data
 * @returns
 */
export function copyChildToChannel(data, module) {
  var url = "/decoration/decoration/copy-child-page-to-channel-shop";
  if (module === 'admin') {
    url = "/decoration/decoration/copy-child-page-to-channel";
  } else if (module === 'custom') {
    url = '/decoration/decoration/copy-child-page-to-channel-customer';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 子页面 - 获取当日达菜单接口
 * @param {*} params
 * @returns
 */
export function getChildCategoryToday(params, module) {
  var url = {
    admin: '/decoration/decoration/child-category-today',
    custom: '/decoration/decoration/child-category-today-customer',
    plat_custom: '/plat/decoration/child-category-today-customer',
    channel: '/decoration/decoration/child-category-today-shop'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 子页面相关 - end
 */

// 超级组件start

/**
 * 超级组件装修 - 列表
 * @param {*} params
 * @returns
 */
export function getSuperWidgetList(params) {
  return request({
    url: '/decoration/decoration-super/index',
    method: 'get',
    params: params
  });
}
/**
 * 超级组件 - 禁用/启用
 * @param {*} data
 * @returns
 */
export function changeSuperWidgetStatus(data) {
  return request({
    url: '/decoration/decoration-super/change-status',
    method: 'post',
    data: data
  });
}
/**
 * 超级组件 - 删除超级组件
 * @param {*} data
 * @returns
 */
export function delSuperWidget(data) {
  return request({
    url: '/decoration/decoration-super/delete',
    method: 'post',
    data: data
  });
}
/**
 * 超级组件 - 获取装修首页
 * @param {*} params
 * @returns
 */
export function getSuperWidgetHome(params) {
  return request({
    url: '/decoration/decoration-super/home',
    method: 'get',
    params: params
  });
}
/**
 * 超级组件 - 获取组件列表
 * @param {*} params
 * @returns
 */
export function getSuperWidget(params) {
  return request({
    url: '/decoration/decoration-super/widget',
    method: 'get',
    params: params
  });
}
/**
 * 超级组件 - 单组件保存
 * @param {*} data
 * @returns
 */
export function superWidgetUpdate(data) {
  return request({
    url: '/decoration/decoration-super/update',
    method: 'post',
    data: data
  });
}
/**
 * 超级组件 - 保存装修
 * @param {*} data
 * @returns
 */
export function saveSuperWidget(data) {
  return request({
    url: '/decoration/decoration-super/save',
    method: 'post',
    data: data
  });
}
/**
 * 超级组件 - 获取组件值
 * @param {*} data
 * @returns
 */
export function getWidgetValue(data) {
  return request({
    url: '/decoration/decoration-super/get-widget-value',
    method: 'post',
    data: data
  });
}
/**
 * 超级组件 - 从左侧面板 带查询条件获取组件列表
 * @param {*} params
 * @returns
 */
export function getWidgetList(params) {
  return request({
    url: '/decoration/decoration-super/get-page-widget',
    method: 'get',
    params: params
  });
}
// 超级组件end

/**
 * 获取卡包样式
 * @param {*} params
 * @returns
 */
export function getCardStyle(params, module) {
  var url = {
    admin: '/decoration/decoration/get-channel-card-style',
    channel: '/decoration/decoration/get-mall-card-style'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 设置卡包样式
 * @param {*} data
 * @returns
 */
export function setCardStyle(data, module) {
  var url = {
    admin: '/decoration/decoration/save-channel-card-style',
    channel: '/decoration/decoration/save-mall-card-style'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 获取客户级卡包样式
 * @param {*} params
 * @returns
 */
export function getCardStyleCustomer(params) {
  return request({
    url: '/decoration/decoration/card-home-by-customer',
    method: 'get',
    params: params
  });
}

/**
 * 保存客户级卡包样式
 * @param {*} data
 * @returns
 */
export function setCardStyleCustomer(data) {
  return request({
    url: '/decoration/decoration/card-home-by-customer',
    method: 'post',
    data: data
  });
}

/**
 * 获取客户级商品详情页装修配置
 * @param {*} params
 * @returns
 */
export function getGoodsPageConfig(params) {
  return request({
    url: '/decoration/decoration/goods-home-by-customer',
    method: 'get',
    params: params
  });
}

/**
 * 保存客户级商品详情页装修基础信息
 * @param {*} data
 * @returns
 */
export function saveGoodsPageBasic(data) {
  return request({
    url: '/decoration/decoration/goods-basic-by-customer',
    method: 'post',
    data: data
  });
}

/**
 * banner组件获取不同模块下商品列表
 * @param {*} params
 * @returns
 */
export function getGoodList(params, module) {
  var url = '/decoration/decoration/get-goods-list';
  if (module === 'plat_custom') {
    url = '/plat/decoration/get-goods-list';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取书籍列表
 * @param {*} params
 * @param {*} module
 * @returns
 */
export function getBookList(params, module) {
  return request({
    url: '/decoration/decoration/get-union-book-list',
    method: 'get',
    params: params
  });
}

// 分类装修页 start

/**
 * 分类装修 - 获取主数据
 * @param {*} params
 * @returns
 */
export function getHomeDataByCategory(params, module) {
  var url = {
    admin: '/decoration/decoration/menus-home',
    channel: '/decoration/decoration/current-menus-home',
    custom: '/decoration/decoration/menus-home-by-customer',
    plat_custom: '/plat/decoration/menus-home-by-customer',
    service_custom: '/kefu/decoration/menus-home-by-customer',
    plat_service_custom: '/plat-service/decoration/menus-home-by-customer'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 保存分类页装修并发布
 * @param {*} data
 * @returns
 */
// export function saveByCategory(data, module) {
// 	const url = {
// 		admin: '/decoration/decoration/save-by-menus',
// 		custom: '/decoration/decoration/save-by-customer-menus',
// 		plat_custom: '/plat/decoration/save-by-customer-menus',
// 		channel: '/decoration/decoration/current-save-by-menus'
// 	}[module]
// 	return request({
// 		url,
// 		method: 'post',
// 		data
// 	})
// }

/**
 * 分类装修 - 基础设置页
 * @param {*} params
 * @returns
 */
export function getBasicByCategory(params, module) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
  var url = {
    admin: '/decoration/decoration/menus-basic',
    channel: '/decoration/decoration/current-menus-basic',
    custom: '/decoration/decoration/menus-basic-by-customer',
    plat_custom: '/plat/decoration/menus-basic-by-customer',
    service_custom: '/kefu/decoration/menus-basic-by-customer',
    plat_service_custom: '/plat-service/decoration/menus-basic-by-customer'
  }[module];
  return request(_objectSpread({
    url: url,
    method: method
  }, method === 'get' ? {
    params: params
  } : {
    data: params
  }));
}

/**
 * 分类装修 - 获取组件列表
 * @param {*} params
 * @returns
 */
export function getComponentsByCategory(params, module) {
  var url = {
    admin: '/decoration/decoration/menus-widget',
    channel: '/decoration/decoration/menus-widget',
    custom: '/decoration/decoration/menus-widget',
    plat_custom: '/plat/decoration/menus-widget',
    service_custom: '/kefu/decoration/menus-widget',
    plat_service_custom: '/plat-service/decoration/menus-widget'
  }[module] || '/decoration/decoration/menus-widget';
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
// 分类装修页 end

/**
 * 获取商城首页主页面 & 备用页面
 * @param {*} params
 * @returns
 */
export function getMainTemplate(params) {
  return request({
    url: '/decoration/decoration/get-main-template',
    method: 'get',
    params: params
  });
}
/**
 * 设置主商城
 * @param {*} data
 * @returns
 */
export function setMainTemplate(module, data) {
  var url = {
    admin: '/decoration/decoration/set-main-template',
    channel: '/decoration/decoration/set-current-main-template'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 删除子商城
 * @param {*} data
 * @returns
 */
export function removeMainTemplate(module, data) {
  var url = {
    admin: '/decoration/decoration/delete-main-template',
    channel: '/decoration/decoration/delete-current-main-template'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 渠道 主页面&备用页面更改名称
 * @param {*} data
 * @returns
 */
export function templateRename(module, data) {
  var url = {
    admin: '/decoration/decoration/save-template-name',
    channel: '/decoration/decoration/save-template-name-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 渠道 主页面&备用页面复制
 * @param {*} data
 * @returns
 */
export function copyTemplate(module, data) {
  var url = {
    admin: '/decoration/decoration/copy-template',
    channel: '/decoration/decoration/copy-template-shop'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 获取弹框设置列表
 * @param {*} params
 * @returns
 */
export function getPopupList(params) {
  return request({
    url: '/decoration/channel-notice/list',
    method: 'get',
    params: params
  });
}
/**
 * 获取弹框设置详情
 * @param {*} params
 * @returns
 */
export function getPopupDetail(params) {
  return request({
    url: '/decoration/channel-notice/detail',
    method: 'get',
    params: params
  });
}
// 弹框设置-保存
export function savePopupSet(data) {
  return request({
    url: '/decoration/channel-notice/save',
    method: 'post',
    data: data
  });
}
// 弹框设置-删除
export function delPopupSet(data) {
  return request({
    url: '/decoration/channel-notice/del',
    method: 'post',
    data: data
  });
}

/**
 * 获取弹框设置详情 - 渠道下企业
 * @param {*} params
 * @returns
 */
export function getAcccountList(params) {
  return request({
    url: '/decoration/channel-notice/get-account-by-channel',
    method: 'get',
    params: params
  });
}

/**
 * 功能菜单装修 - 获取搜索项下拉列表
 * @param {*} params
 * @returns
 */
export function getOptions(params) {
  return request({
    url: '/decoration/decoration/decoration-category-search',
    method: 'get',
    params: params
  });
}
/**
 * 功能菜单 - 个人中心装修 获取
 * @param {*} params
 * @returns
 */
export function getUserCenterSettings(params) {
  return request({
    url: '/decoration/decoration/get-user-center-settings',
    method: 'get',
    params: params
  });
}
// 功能菜单 - 个人中心装修 设置
export function setUserCenterSettings(data) {
  return request({
    url: '/decoration/decoration/set-user-center-settings',
    method: 'post',
    data: data
  });
}
// 功能菜单 - 基础装修 获取
export function getBasic(params) {
  return request({
    url: '/decoration/decoration-basic/get-basic',
    method: 'get',
    params: params
  });
}
// 功能菜单 - 基础装修 设置
export function saveBasic(data) {
  return request({
    url: '/decoration/decoration-basic/save-basic',
    method: 'post',
    data: data
  });
}
/**
 * 功能菜单 - 获取通知消息配置
 * @param {*} params customer_id、category_id
 */
export function getCategoryPageNotice(params) {
  return request({
    url: '/decoration/decoration/get-category-page-notice-by-customer',
    method: 'get',
    params: params
  });
}
// 功能菜单 - 保存通知消息配置
export function saveCategoryPageNotice(data) {
  return request({
    url: '/decoration/decoration/save-category-page-notice-by-customer',
    method: 'post',
    data: data
  });
}
/**
 * 功能菜单 - 获取客户可选通知消息列表
 * @param {*} params customer_id
 */
export function getChannelNoticeList(params) {
  return request({
    url: '/decoration/decoration/get-channel-notice-list',
    method: 'get',
    params: params
  });
}
export function getGifList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index',
    method: 'get',
    params: params
  });
}
// https://vouchertest.youlianfuwu.com/mapdepot/map-depot-type/index?type_id=127&page=1&pagesize=10&request=true&name=

export function getTemplate(params) {
  return request({
    url: '/decoration/template/get-thumb',
    method: 'get',
    params: params
  });
}